import React from 'react';
import { Helmet } from 'react-helmet';

class HtmlHeader extends React.Component {
  render() {
    return (
      <Helmet titleTemplate={'%s'} defaultTitle={'DFIM Opslag'}>
        {/* Required meta tags */}
        <html lang={'en'} amp />
        <meta charset={'utf-8'} />
        <meta name={'viewport'} content={'width=device-width, initial-scale=1, shrink-to-fit=no'} />

        <meta name={'description'} content={'DFIM Opslag; a Less built for your DFIM needs.'} />
        <meta name={'author'} content={'Process Factory'} />

        <title>Onelogic - DFIM Opslag</title>
      </Helmet>
    );
  }
}

export default HtmlHeader;
